import { Skeleton } from '@savvy-kit/components/skeleton';
import { Table, TableBody, TableCell, TableRow } from '@savvy-kit/components/table';
import { Text } from '@savvy-kit/foundations/text';

type AccountsTableSkeletonProps = {
  readonly title: string;
};

export function AccountsTableSkeleton({ title }: AccountsTableSkeletonProps) {
  return (
    <div className="opacity-100">
      {/* The real table's title sits above it rather than in a row; match that so the
          skeleton and the loaded table do not shift relative to each other. */}
      <div className="flex flex-row gap-4 pb-3 pl-0 pr-0.5 pt-5">
        <Text variant="h4">{title}</Text>
      </div>
      <Table aria-label="Asset Group Table" containerClassName="overflow-x-visible">
        <TableBody>
          {Array.from({ length: 4 }, (_, index) => (
            <SkeletonRow key={index} />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

function SkeletonRow() {
  return (
    <TableRow className="border-b-0 hover:bg-transparent">
      <TableCell className="w-[35%]">
        <div className="pl-2">
          <div className="flex items-center">
            <div className="pr-4">
              <Skeleton className="rounded-full w-[42px] h-[42px]" />
            </div>
            <div className="flex flex-col gap-0">
              <Skeleton className="w-[76px] h-[16px]" />
              <Skeleton className="w-[157px] h-[16px]" />
            </div>
          </div>
        </div>
      </TableCell>
      <TableCell className="w-[14%] text-left">
        <Skeleton className="h-[16px]" />
      </TableCell>
      <TableCell className="w-[14%] text-right">
        <Skeleton className="h-[16px]" />
      </TableCell>
      <TableCell className="w-[23%] text-right">
        <div className="flex flex-row items-center justify-end">
          <Skeleton className="w-[76px] h-[16px]" />
        </div>
      </TableCell>
    </TableRow>
  );
}
